/**
 * @file: AccountTxType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum AccountTxType {
  ProductReferring = 'product_referring',
  ProductAdoption = 'product_adoption',
  ProductClosing = 'product_closing',
  ProductReferringShare = 'product_referring_share',
  ProductAdoptionShare = 'product_adoption_share',
  ProductClosingShare = 'product_closing_share',
  RevokeProductReferring = 'revoke_product_referring',
  RevokeProductAdoption = 'revoke_product_adoption',
  RevokeProductClosing = 'revoke_product_closing',
  RevokeProductReferringShare = 'revoke_product_referring_share',
  RevokeProductAdoptionShare = 'revoke_product_adoption_share',
  RevokeProductClosingShare = 'revoke_product_closing_share',
  CampaignReward = 'campaign_reward',
  CampaignRewardShare = 'campaign_reward_share',
  RevokeCampaignReward = 'revoke_campaign_reward',
  RevokeCampaignRewardShare = 'revoke_campaign_reward_share',
  Withdraw = 'withdraw',
  Refund = 'refund',
}

export const AccountTxTypeValueSet = new Set([
  AccountTxType.ProductReferring,
  AccountTxType.ProductAdoption,
  AccountTxType.ProductClosing,
  AccountTxType.ProductReferringShare,
  AccountTxType.ProductAdoptionShare,
  AccountTxType.ProductClosingShare,
  AccountTxType.RevokeProductReferring,
  AccountTxType.RevokeProductAdoption,
  AccountTxType.RevokeProductClosing,
  AccountTxType.RevokeProductReferringShare,
  AccountTxType.RevokeProductAdoptionShare,
  AccountTxType.RevokeProductClosingShare,
  AccountTxType.CampaignReward,
  AccountTxType.CampaignRewardShare,
  AccountTxType.RevokeCampaignReward,
  AccountTxType.RevokeCampaignRewardShare,
  AccountTxType.Withdraw,
  AccountTxType.Refund,
]);
